import { LogsCronItemIProps } from "~/entity/Logs/model/schema";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import { stringListToSelectOption } from "~/shared/lib/StringListToSelectOption/stringListToSelectOption";

export const dateFormater = (data: LogsCronItemIProps[]) => {
  const newData = data.map((dataItem) => {
    const { start, end, ...rest } = dataItem;
    return {
      ...rest,
      start: start ? dateFormat(new Date(start), { type: "datetime" }) : "",
      end: end ? dateFormat(new Date(end), { type: "datetime" }) : "",
    };
  });
  return newData;
};

export const formaterLogNames = (data: string[]) => {
  return data.map(stringListToSelectOption);
};
